<!-- 轮播通用组件 -->
<template>
    <CustomCarousel 
        :bannerList="bannerList" 
        :fileUrl="fileUrl"
        :height="height" 
        :isMainBanner="isMainBanner" 
        :imgHeight="imgHeight" 
        :imgWidth="imgWidth"
        @clickImageJump="clickImageJump"
        >
    </CustomCarousel>
</template>

<script>
    import CustomCarousel from 'components/CustomCarousel/index.vue'
    import * as api_advertising from 'service/api/methods/api_advertising.js' //接口

    export default {
        components:{
            CustomCarousel,
        },
        props:{
            bannerList:{
                type:Array,
                default:()=>{
                    return [];
                }
            },
            fileUrl:{//文件前缀
                type:String,
                default:""
            },
            height:{
                type:String,
                default:'500px'
            },
            imgHeight:{//图片的高度
                type:String,
                default:''
            },
            imgWidth:{//图片的宽度
                type:String,
                default:''
            },
            isMainBanner:{//主要用于宽度适配
                type:Boolean,
                default:true,
            },
        },
        data() {
            return {
            }
        },
        created(){
        },
        methods:{
            clickImageJump(url,bannerid){
                if(this.$utils.isNoNullAll(url)){
                    window.open(url);
                    let p={
                        bannerid:bannerid,
                    }
                    api_advertising.addClickRate(p).then((res) => {
                    }).catch((earr) => {
                        console.log(earr);
                    });
                }
            }
        }
    }
</script>

<style lang="less" scoped>
</style>